import { useTranslation } from "react-i18next";
import logo from "@images/logo.svg";

export default function FooterSection() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const companyLinks = [
    { labelKey: "footer.nav_about", id: "about" },
    { labelKey: "footer.nav_team", id: "team" },
    { labelKey: "footer.nav_tech", id: "services" },
    { labelKey: "footer.nav_recruit", id: "contact" },
  ];
  const serviceLinks = [
    { labelKey: "footer.nav_momo", id: "momo" },
    { labelKey: "footer.nav_social", id: "social" },
    { labelKey: "footer.nav_invest", id: "contact" },
    { labelKey: "footer.nav_partner", id: "contact" },
  ];

  return (
    <footer
      className="px-4 pt-14 pb-8"
      style={{ backgroundColor: "oklch(0.09 0.001 10)" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Top grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b"
          style={{ borderColor: "rgba(255,255,255,0.06)" }}
        >
          {/* Brand */}
          <div className="md:col-span-2">
            <img src={logo} alt="IKOB 로고" className="h-8 mb-4" />
            <p className="text-sm font-label leading-relaxed mb-3" style={{ color: "rgba(255,255,255,0.45)" }}>
              {t("footer.tagline")}<br />
              {t("footer.momo_desc")}
            </p>
            <p className="text-xs font-label tracking-widest mb-6" style={{ color: "rgba(255,255,255,0.25)" }}>
              {t("footer.tagline2")}
            </p>
            <div className="space-y-1.5 text-xs font-label" style={{ color: "rgba(255,255,255,0.35)" }}>
              <p><strong style={{ color: "rgba(255,255,255,0.55)" }}>{t("footer.company_name")}</strong></p>
              <p>{t("footer.ceo_prefix")} {t("footer.ceo_name")}</p>
              <p>{t("footer.address")}</p>
              <p>
                <a href="tel:+82264780021" className="hover:underline" style={{ color: "rgba(255,255,255,0.35)" }}>
                  02-6478-0021
                </a>
                {" · "}
                <a href="mailto:ikob@ikob.kr" className="hover:underline" style={{ color: "rgba(255,255,255,0.35)" }}>
                  ikob@ikob.kr
                </a>
                {" · "}
                <a
                  href="https://ikob.kr"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:underline"
                  style={{ color: "rgba(255,255,255,0.35)" }}
                >
                  ikob.kr
                </a>
              </p>
            </div>
          </div>

          {/* Company nav */}
          <div>
            <h4 className="font-heading font-bold text-sm mb-4" style={{ color: "rgba(255,255,255,0.7)" }}>
              {t("footer.nav_company")}
            </h4>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.labelKey}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="cursor-pointer text-xs font-label hover:underline text-left whitespace-nowrap"
                    style={{ color: "rgba(255,255,255,0.40)" }}
                  >
                    {t(link.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services nav */}
          <div>
            <h4 className="font-heading font-bold text-sm mb-4" style={{ color: "rgba(255,255,255,0.7)" }}>
              {t("footer.nav_services")}
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.labelKey}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="cursor-pointer text-xs font-label hover:underline text-left whitespace-nowrap"
                    style={{ color: "rgba(255,255,255,0.40)" }}
                  >
                    {t(link.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label" style={{ color: "rgba(255,255,255,0.25)" }}>
            {t("footer.copyright")} |{" "}
            <a
              href="https://ikob.kr"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="hover:underline"
              style={{ color: "rgba(255,255,255,0.35)" }}
            >
              ikob.kr
            </a>
          </p>
          <p className="text-xs font-label" style={{ color: "rgba(255,255,255,0.20)" }}>
            {t("footer.sub_tagline")}
          </p>
        </div>
      </div>
    </footer>
  );
}